// import { Link } from "react-router-dom";
// import { motion } from "framer-motion";
// import { ArrowRight, Database, Shield, Activity, Zap } from "lucide-react";

// export default function CloudPage() {
//   return (
//     <main style={{ backgroundColor: "#ffffff" }}>
//       {/* Hero with Accent Background */}
//       <section
//         style={{
//           background:
//             "linear-gradient(to bottom, #667eea 0%, #667eea 50%, white 100%)",
//           padding: "100px 20px 60px",
//           color: "white",
//         }}
//       >
//         <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//           >
//             <h1
//               style={{
//                 fontSize: "48px",
//                 fontWeight: "bold",
//                 marginBottom: "20px",
//                 lineHeight: "1.2",
//               }}
//             >
//               Cloud Solutions & DevOps
//             </h1>
//             <p
//               style={{
//                 fontSize: "18px",
//                 opacity: 0.95,
//                 maxWidth: "600px",
//                 marginBottom: "40px",
//               }}
//             >
//               Migrate, deploy, and scale your applications on cloud
//               infrastructure with enterprise-grade security
//             </p>
//           </motion.div>
//         </div>
//       </section>

//       {/* Cloud Providers */}
//       <section style={{ padding: "80px 20px", backgroundColor: "white" }}>
//         <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
//           <h2
//             style={{
//               fontSize: "36px",
//               fontWeight: "bold",
//               marginBottom: "50px",
//               color: "#1a202c",
//             }}
//           >
//             Cloud Platforms We Support
//           </h2>

//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
//               gap: "30px",
//             }}
//           >
//             {[
//               {
//                 name: "AWS",
//                 features: [
//                   "EC2 & ECS",
//                   "RDS & DynamoDB",
//                   "Lambda functions",
//                   "S3 storage",
//                   "CloudFront CDN",
//                 ],
//               },
//               {
//                 name: "Microsoft Azure",
//                 features: [
//                   "App Service",
//                   "SQL Database",
//                   "Cosmos DB",
//                   "Blob Storage",
//                   "CDN services",
//                 ],
//               },
//               {
//                 name: "Google Cloud",
//                 features: [
//                   "Compute Engine",
//                   "Cloud SQL",
//                   "Firestore",
//                   "Cloud Storage",
//                   "Cloud CDN",
//                 ],
//               },
//             ].map((provider, idx) => (
//               <motion.div
//                 key={idx}
//                 initial={{ opacity: 0, scale: 0.95 }}
//                 animate={{ opacity: 1, scale: 1 }}
//                 transition={{ duration: 0.6, delay: idx * 0.1 }}
//                 style={{
//                   background: "white",
//                   border: "2px solid #e2e8f0",
//                   padding: "40px",
//                   borderRadius: "12px",
//                   textAlign: "center",
//                 }}
//               >
//                 <h3
//                   style={{
//                     fontSize: "24px",
//                     fontWeight: "bold",
//                     marginBottom: "25px",
//                     color: "#667eea",
//                   }}
//                 >
//                   {provider.name}
//                 </h3>
//                 <ul
//                   style={{ listStyle: "none", padding: 0, textAlign: "left" }}
//                 >
//                   {provider.features.map((feature, i) => (
//                     <li
//                       key={i}
//                       style={{
//                         padding: "8px 0",
//                         color: "#718096",
//                         borderBottom:
//                           i !== provider.features.length - 1
//                             ? "1px solid #e2e8f0"
//                             : "none",
//                       }}
//                     >
//                       • {feature}
//                     </li>
//                   ))}
//                 </ul>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Services Breakdown */}
//       <section style={{ padding: "80px 20px", backgroundColor: "#f5f7fa" }}>
//         <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
//           <h2
//             style={{
//               fontSize: "36px",
//               fontWeight: "bold",
//               marginBottom: "50px",
//               color: "#1a202c",
//             }}
//           >
//             Cloud Services We Offer
//           </h2>

//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
//               gap: "25px",
//             }}
//           >
//             {[
//               {
//                 icon: Database,
//                 title: "Cloud Migration",
//                 desc: "Seamless migration of applications and databases to cloud",
//               },
//               {
//                 icon: Shield,
//                 title: "Security & Compliance",
//                 desc: "Enterprise security, encryption, and compliance setup",
//               },
//               {
//                 icon: Activity,
//                 title: "Monitoring & Support",
//                 desc: "24/7 monitoring and proactive maintenance",
//               },
//               {
//                 icon: Zap,
//                 title: "CI/CD Pipeline",
//                 desc: "Automated deployment and continuous integration",
//               },
//             ].map((service, idx) => {
//               const Icon = service.icon;
//               return (
//                 <motion.div
//                   key={idx}
//                   initial={{ opacity: 0, y: 20 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.6, delay: idx * 0.1 }}
//                   style={{
//                     background: "white",
//                     padding: "30px",
//                     borderRadius: "12px",
//                     boxShadow: "0 4px 15px rgba(0, 0, 0, 0.08)",
//                   }}
//                 >
//                   <Icon
//                     size={36}
//                     style={{ color: "#667eea", marginBottom: "16px" }}
//                   />
//                   <h3
//                     style={{
//                       fontSize: "18px",
//                       fontWeight: "bold",
//                       marginBottom: "12px",
//                       color: "#1a202c",
//                     }}
//                   >
//                     {service.title}
//                   </h3>
//                   <p style={{ color: "#718096", fontSize: "14px" }}>
//                     {service.desc}
//                   </p>
//                 </motion.div>
//               );
//             })}
//           </div>
//         </div>
//       </section>

//       {/* Migration Process */}
//       <section style={{ padding: "80px 20px", backgroundColor: "white" }}>
//         <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
//           <h2
//             style={{
//               fontSize: "36px",
//               fontWeight: "bold",
//               marginBottom: "50px",
//               color: "#1a202c",
//             }}
//           >
//             Cloud Migration Process
//           </h2>

//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
//               gap: "20px",
//             }}
//           >
//             {[
//               {
//                 phase: "Assessment",
//                 duration: "Week 1-2",
//                 tasks: "Analyze current infrastructure and cloud requirements",
//               },
//               {
//                 phase: "Planning",
//                 duration: "Week 3-4",
//                 tasks: "Design cloud architecture and migration strategy",
//               },
//               {
//                 phase: "Preparation",
//                 duration: "Week 5-6",
//                 tasks: "Set up cloud resources and test environment",
//               },
//               {
//                 phase: "Migration",
//                 duration: "Week 7-8",
//                 tasks: "Execute migration with minimal downtime",
//               },
//               {
//                 phase: "Optimization",
//                 duration: "Week 9-10",
//                 tasks: "Optimize performance and reduce costs",
//               },
//               {
//                 phase: "Support",
//                 duration: "Ongoing",
//                 tasks: "24/7 monitoring and continuous improvement",
//               },
//             ].map((item, idx) => (
//               <motion.div
//                 key={idx}
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.6, delay: idx * 0.1 }}
//                 style={{
//                   background: "#f5f7fa",
//                   padding: "25px",
//                   borderRadius: "8px",
//                   borderLeft: "4px solid #667eea",
//                 }}
//               >
//                 <h3
//                   style={{
//                     fontSize: "18px",
//                     fontWeight: "bold",
//                     color: "#667eea",
//                     marginBottom: "8px",
//                   }}
//                 >
//                   {item.phase}
//                 </h3>
//                 <p
//                   style={{
//                     color: "#718096",
//                     fontSize: "13px",
//                     marginBottom: "8px",
//                   }}
//                 >
//                   {item.duration}
//                 </p>
//                 <p style={{ color: "#2d3748" }}>{item.tasks}</p>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Benefits */}
//       <section style={{ padding: "80px 20px", backgroundColor: "#f5f7fa" }}>
//         <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
//           <h2
//             style={{
//               fontSize: "36px",
//               fontWeight: "bold",
//               marginBottom: "50px",
//               color: "#1a202c",
//             }}
//           >
//             Benefits of Cloud
//           </h2>

//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "1fr 1fr",
//               gap: "40px",
//             }}
//           >
//             <motion.div
//               initial={{ opacity: 0, x: -20 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.6 }}
//             >
//               <h3
//                 style={{
//                   fontSize: "22px",
//                   fontWeight: "bold",
//                   marginBottom: "25px",
//                   color: "#1a202c",
//                 }}
//               >
//                 Cost Benefits
//               </h3>
//               {[
//                 "Pay-as-you-go pricing",
//                 "Reduced capital expenses",
//                 "Lower operational costs",
//                 "No hardware investment",
//               ].map((item, idx) => (
//                 <motion.div
//                   key={idx}
//                   initial={{ opacity: 0, x: -10 }}
//                   animate={{ opacity: 1, x: 0 }}
//                   transition={{ duration: 0.5, delay: idx * 0.05 }}
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "12px",
//                     marginBottom: "16px",
//                   }}
//                 >
//                   <span style={{ color: "#667eea", fontSize: "18px" }}>✓</span>
//                   <span style={{ color: "#2d3748" }}>{item}</span>
//                 </motion.div>
//               ))}
//             </motion.div>

//             <motion.div
//               initial={{ opacity: 0, x: 20 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.6 }}
//             >
//               <h3
//                 style={{
//                   fontSize: "22px",
//                   fontWeight: "bold",
//                   marginBottom: "25px",
//                   color: "#1a202c",
//                 }}
//               >
//                 Performance Benefits
//               </h3>
//               {[
//                 "Auto-scaling",
//                 "99.99% uptime",
//                 "Global presence",
//                 "Better performance",
//               ].map((item, idx) => (
//                 <motion.div
//                   key={idx}
//                   initial={{ opacity: 0, x: 10 }}
//                   animate={{ opacity: 1, x: 0 }}
//                   transition={{ duration: 0.5, delay: idx * 0.05 }}
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "12px",
//                     marginBottom: "16px",
//                   }}
//                 >
//                   <span style={{ color: "#667eea", fontSize: "18px" }}>✓</span>
//                   <span style={{ color: "#2d3748" }}>{item}</span>
//                 </motion.div>
//               ))}
//             </motion.div>
//           </div>
//         </div>
//       </section>

//       {/* CTA */}
//       <section
//         style={{
//           background: "linear-gradient(to right, #667eea 0%, #764ba2 100%)",
//           padding: "80px 20px",
//           color: "white",
//         }}
//       >
//         <div
//           style={{ maxWidth: "900px", margin: "0 auto", textAlign: "center" }}
//         >
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//           >
//             <h2
//               style={{
//                 fontSize: "36px",
//                 fontWeight: "bold",
//                 marginBottom: "20px",
//               }}
//             >
//               Ready to Move to Cloud?
//             </h2>
//             <p style={{ fontSize: "16px", opacity: 0.9, marginBottom: "30px" }}>
//               Let's plan your cloud migration and optimize your infrastructure
//             </p>
//             <Link
//               href="/contact"
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: "10px",
//                 background: "white",
//                 color: "#667eea",
//                 padding: "14px 32px",
//                 borderRadius: "8px",
//                 fontWeight: "600",
//                 textDecoration: "none",
//               }}
//             >
//               Consult with Experts <ArrowRight size={20} />
//             </Link>
//           </motion.div>
//         </div>
//       </section>
//     </main>
//   );
// }

import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  ArrowRight,
  Database,
  ShieldCheck,
  Activity,
  Zap,
  Cloud,
  Server,
  Network,
  CheckCircle2,
  Lock,
  BarChart3,
  Cpu,
} from "lucide-react";


const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 },
};

export default function CloudPage() {
  return (
    <main className="bg-white font-inter selection:bg-indigo-100 text-slate-900">
      {/* ================= HERO SECTION ================= */}
      <section className="relative h-[450px] flex items-center overflow-hidden bg-[#0f172a]">
        {/* Tech-inspired background overlay */}
        <div
          className="absolute inset-0 bg-cover bg-center opacity-20 scale-105"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1920&q=80')",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f172a] via-[#0f172a]/90 to-transparent" />

        {/* Dynamic Grid Pattern */}
        <div
          className="absolute inset-0 opacity-[0.05] pointer-events-none"
          style={{
            backgroundImage: `radial-gradient(#4f46e5 0.5px, transparent 0.5px)`,
            backgroundSize: "30px 30px",
          }}
        />

        <div className="relative max-w-7xl mx-auto px-6 w-full">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-2xl"
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[10px] font-bold tracking-[0.3em] uppercase mb-6">
              Cloud Infrastructure
            </div>
            <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6 tracking-tight leading-tight">
              Cloud Solutions & <span className="text-indigo-400">DevOps.</span>
            </h1>
            <p className="text-lg text-slate-300 text-white mb-8 leading-relaxed font-light">
              Migrate, deploy, and scale with high-availability infrastructure
              engineered for sub-second latency and enterprise-grade resilience.
            </p>
            <div className="flex gap-4">
              <Link
                to="/contact"
                className="bg-indigo-600 text-white px-8 py-3 rounded-lg text-sm font-bold hover:bg-indigo-700 transition-all shadow-lg shadow-indigo-900/40 flex items-center gap-2"
              >
                Initiate Migration <ArrowRight size={16} />
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ================= PLATFORMS SECTION ================= */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-indigo-600 text-[11px] font-bold tracking-[0.2em] uppercase block mb-3">
              Multi-Cloud Ecosystem
            </span>
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight">
              Certified Infrastructure Support
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                name: "AWS",
                desc: "Enterprise compute and serverless architectures.",
                features: [
                  "EC2 & ECS Orchestration",
                  "Aurora & DynamoDB",
                  "Lambda Edge Functions",
                  "CloudFront CDN",
                ],
              },
              {
                name: "Microsoft Azure",
                desc: "Integrated hybrid cloud solutions for scalability.",
                features: [
                  "App Service Environments",
                  "Azure SQL Managed Instance",
                  "Cosmos DB Integration",
                  "Blob Storage Tiers",
                ],
              },
              {
                name: "Google Cloud",
                desc: "Data-heavy compute and modern AI infrastructure.",
                features: [
                  "Kubernetes Engine (GKE)",
                  "Cloud SQL & Spanner",
                  "Firebase Ecosystem",
                  "Vertex AI Ready",
                ],
              },
            ].map((provider, idx) => (
              <motion.div
                key={idx}
                {...fadeUp}
                className="group p-8 rounded-2xl border border-slate-100 bg-white hover:border-indigo-100 hover:shadow-xl transition-all"
              >
                <h3 className="text-2xl font-black text-slate-900 mb-2 group-hover:text-indigo-600 transition-colors">
                  {provider.name}
                </h3>
                <p className="text-xs text-slate-400 mb-6 uppercase tracking-widest font-bold">
                  {provider.desc}
                </p>
                <ul className="space-y-4">
                  {provider.features.map((feature, i) => (
                    <li
                      key={i}
                      className="flex items-center gap-3 text-sm text-slate-600 font-medium"
                    >
                      <CheckCircle2
                        size={16}
                        className="text-indigo-600 shrink-0"
                      />
                      {feature}
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= SERVICE BREAKDOWN (BENTO) ================= */}
      <section className="py-24 bg-slate-50 border-y border-slate-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center mb-16">
            <motion.div {...fadeUp}>
              <h2 className="text-3xl font-bold text-slate-900 mb-6">
                Core Engineering Capabilities
              </h2>
              <p className="text-slate-600 leading-relaxed font-light text-lg">
                We bridge the gap between development and operations through
                automated pipelines and hardened security protocols.
              </p>
            </motion.div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              {
                icon: Network,
                title: "Cloud Migration",
                desc: "Low-downtime transition of legacy monoliths to microservices.",
              },
              {
                icon: Lock,
                title: "SecOps Compliance",
                desc: "Automated vulnerability scanning and IAM policy hardening.",
              },
              {
                icon: Activity,
                title: "Real-time Telemetry",
                desc: "Proactive monitoring with automated incident response.",
              },
              {
                icon: Zap,
                title: "CI/CD Automation",
                desc: "Zero-touch deployment pipelines for rapid release cycles.",
              },
            ].map((service, idx) => (
              <motion.div
                key={idx}
                {...fadeUp}
                transition={{ delay: idx * 0.1 }}
                className="bg-white p-8 rounded-2xl border border-slate-200 shadow-sm hover:shadow-md transition-all"
              >
                <div className="w-10 h-10 bg-slate-50 flex items-center justify-center rounded-xl text-indigo-600 mb-6">
                  <service.icon size={20} />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-3 tracking-tight">
                  {service.title}
                </h3>
                <p className="text-[13px] text-slate-500 leading-relaxed font-light">
                  {service.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= STRATEGIC IMPACT ================= */}
      <section className="py-24 bg-slate-900 text-white relative overflow-hidden">
        <div className="absolute top-0 right-0 w-64 h-64 bg-indigo-500/10 blur-[100px] rounded-full" />
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-3xl font-bold mb-8">
                Architectural Performance
              </h2>
              <div className="grid sm:grid-cols-2 gap-8">
                <div>
                  <BarChart3 className="text-indigo-400 mb-4" size={32} />
                  <h4 className="font-bold mb-2">Cost Efficiency</h4>
                  <p className="text-sm text-slate-400 font-light leading-relaxed">
                    Pay-as-you-go modeling and serverless compute to eliminate
                    hardware capital.
                  </p>
                </div>
                <div>
                  <Cpu className="text-indigo-400 mb-4" size={32} />
                  <h4 className="font-bold mb-2">Auto-Scaling</h4>
                  <p className="text-sm text-slate-400 font-light leading-relaxed">
                    Infrastructure that expands dynamically based on real-time
                    traffic demand.
                  </p>
                </div>
              </div>
            </div>
            <div className="p-8 bg-white/5 border border-white/10 rounded-2xl backdrop-blur-sm">
              <CheckCircle2 size={32} className="text-indigo-400 mb-4" />
              <h3 className="text-xl font-bold mb-4 tracking-tight">
                Enterprise Availability
              </h3>
              <p className="text-slate-400 text-sm font-light leading-relaxed mb-6">
                Our deployments target 99.99% uptime with global regional
                redundancy, ensuring your application remains accessible
                regardless of localized outages.
              </p>
              <div className="flex gap-4">
                <div className="px-3 py-1 bg-indigo-500/20 rounded text-[10px] font-bold text-indigo-300 border border-indigo-500/30 uppercase tracking-widest">
                  Global CDN
                </div>
                <div className="px-3 py-1 bg-indigo-500/20 rounded text-[10px] font-bold text-indigo-300 border border-indigo-500/30 uppercase tracking-widest">
                  SOC2 Ready
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= FINAL CTA ================= */}
      <section className="py-24 bg-[#0f172a] relative overflow-hidden text-center border-t border-white/5">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-indigo-500/10 rounded-full blur-[120px]" />

        <div className="relative z-10 max-w-4xl mx-auto px-6">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 tracking-tight">
            Ready for Cloud Native?
          </h2>
          <p className="text-slate-400 mb-10 text-lg font-light leading-relaxed max-w-2xl mx-auto">
            Build a resilient digital foundation. Let's design your migration
            roadmap and optimize your infrastructure costs today.
          </p>
          <div className="flex justify-center">
            <Link
              to="/contact"
              className="bg-white text-slate-900 px-10 py-3 rounded-xl font-bold text-sm hover:bg-indigo-50 transition-all shadow-xl"
            >
              Initiate Consultation
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}